export default __webpack_public_path__ + "static/media/functional.1661e450.png";